/**
 * The Insights charts' colours, one system: the brand's inks and surfaces,
 * a categorical set for facility series that passes the colour-vision checks
 * (validated 27 October 2026), a sequential teal ramp for magnitude, and the
 * status pair for movement, which never stands alone - a glyph goes with it.
 */
export const INK = '#0A2830'
export const INK_MID = '#4A6670'
export const GRID = '#E6F0F3'
export const SURFACE = '#F7FBFC'
export const BAND = '#D6EAF0'
export const MARINE = '#0C5E74'
export const GOLD = '#C8A84B'

/** Facility series, assigned in this fixed order, never cycled: a fifth facility is not drawn. */
export const SERIES = ['#2F6FB5', '#D9553F', '#7B5AA6', '#8E7320'] as const
export const MAX_SERIES = SERIES.length

/** Light to dark: the lowest score band to the highest. */
export const SEQUENTIAL = ['#B8D4DC', '#8FB8C8', '#4F93A8', '#0C5E74', '#08404F'] as const

/** Dash patterns that tell the facility series apart beside their colours, in the same fixed order. */
export const SERIES_DASH = [undefined, '10 4', '3 3', '10 4 3 4'] as const

export const GOOD = '#2E8B57'
export const BAD = '#D9553F'
export const FLAT = INK_MID
